module.exports = __webpack_public_path__ + "img/about-puhui.14e93d13.jpg";